// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    display: inline-flex;
    align-items: center;
}

label {
    font-family: var(--p2-regular-font-family);
    font-size: var(--p2-regular-font-size);
    letter-spacing: var(--p2-regular-letter-spacing);
    line-height: var(--p2-regular-line-height);
    font-weight: var(--p2-regular-font-weight);
    margin: 0 var(--spacing-05);
    /*margin-left: var(--spacing-20);*/
    /*margin-right: var(--spacing-20);*/
}

:host([state="error"]) label {
    color: var(--text-error);
}
:host([state="success"]) label {
    color: var(--text-success);
}
:host([state="warning"]) label {
    color: var(--text-warning);
}
`, "",{"version":3,"sources":["webpack://./../website_design_system/src/components/inline_message/style/index.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,0CAA0C;IAC1C,sCAAsC;IACtC,gDAAgD;IAChD,0CAA0C;IAC1C,0CAA0C;IAC1C,2BAA2B;IAC3B,kCAAkC;IAClC,mCAAmC;AACvC;;AAEA;IACI,wBAAwB;AAC5B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B","sourcesContent":[":host {\n    display: inline-flex;\n    align-items: center;\n}\n\nlabel {\n    font-family: var(--p2-regular-font-family);\n    font-size: var(--p2-regular-font-size);\n    letter-spacing: var(--p2-regular-letter-spacing);\n    line-height: var(--p2-regular-line-height);\n    font-weight: var(--p2-regular-font-weight);\n    margin: 0 var(--spacing-05);\n    /*margin-left: var(--spacing-20);*/\n    /*margin-right: var(--spacing-20);*/\n}\n\n:host([state=\"error\"]) label {\n    color: var(--text-error);\n}\n:host([state=\"success\"]) label {\n    color: var(--text-success);\n}\n:host([state=\"warning\"]) label {\n    color: var(--text-warning);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
